<template>
  <k-panel fill-height :body-scrollable="false" searchable :addable="$is_admin()" emit-root emit-type="channels">
    <template #left-buttons>
      <k-tabs large>
        <k-tab name="inputs" to="/channels/inputs/list" label="Inputs"></k-tab>
        <k-tab name="outputs" to="/channels/outputs/list" label="Outputs"></k-tab>
        <k-tab v-if="$is_admin()" name="access_groups" to="/channels/access_groups/list" label="Access groups"></k-tab>
        <k-tab v-if="$is_privilege('developer')" name="configuration_presets" to="/channels/configuration_presets/list" label="Configuration presets"></k-tab>
      </k-tabs>
    </template>
    <template #default>
      <router-view></router-view>
    </template>
  </k-panel>
</template>


<script>
import ChannelInputList from './channels/InputList'
import ChannelOutputList from './channels/OutputList'
import ConfigurationPresetList from './channels/ConfigurationPresetList'
import Editor from './channels/Editor'
import ConfigurationPresetEditor from './channels/ConfigurationPresetEditor'

import AccessGroupList from './channels/AccessGroupList'
import AccessGroupEditor from './channels/AccessGroupEditor'

export default {
  routes: [
    {
      path: '',
      redirect: '/channels/inputs'
    },
    {
      path: "inputs",
      component: ChannelInputList,
      children: [
        {
          path: '',
          redirect: '/channels/inputs/list'
        },
        {
          path: "new",
          name: "New input channel",
          components: {
            default: ChannelInputList,
            bottomEditor: Editor
          },
          props: {
            default: false,
            bottomEditor: true
          },
          meta: {
            edit: "Edit input channel",
            search: false
          }
        },
        {
          path: "edit/:id",
          name: "Edit input channel",
          components: {
            default: ChannelInputList,
            bottomEditor: Editor
          },
          props: {
            default: false,
            bottomEditor: true
          },
          meta: {
            search: false
          }
        },
        {
          path: "list",
          name: "Input list",
          component: ChannelInputList,
          meta: {
            search: false
          }
        }
      ]
    },
    {
      path: "outputs",
      component: ChannelOutputList,
      children: [
        {
          path: '',
          redirect: '/channels/outputs/list'
        },
        {
          path: "new",
          name: "New output channel",
          components: {
            default: ChannelOutputList,
            bottomEditor: Editor
          },
          props: {
            default: false,
            bottomEditor: true
          },
          meta: {
            edit: "Edit output channel",
            search: false
          }
        },
        {
          path: "edit/:id",
          name: "Edit output channel",
          components: {
            default: ChannelOutputList,
            bottomEditor: Editor
          },
          props: {
            default: false,
            bottomEditor: true
          },
          meta: {
            search: false
          }
        },
        {
          path: "list",
          name: "Output list",
          component: ChannelOutputList,
          meta: {
            search: false
          }
        }
      ]
    },
    {
      path: "configuration_presets",
      component: ConfigurationPresetList,
      children: [
        {
          path: '',
          redirect: '/channels/configuration_presets/list'
        },
        {
          path: "new",
          name: "New configuration preset",
          components: {
            default: ConfigurationPresetList,
            bottomEditor: ConfigurationPresetEditor
          },
          props: {
            default: false,
            bottomEditor: true
          },
          meta: {
            edit: "Edit configuration preset",
            search: false
          }
        },
        {
          path: "edit/:id",
          name: "Edit configuration preset",
          components: {
            default: ConfigurationPresetList,
            bottomEditor: ConfigurationPresetEditor
          },
          props: {
            default: false,
            bottomEditor: true
          },
          meta: {
            search: false
          }
        },
        {
          path: "list",
          name: "Configuration Preset list",
          component: ConfigurationPresetList,
          meta: {
            search: false
          }
        }
      ]
    },
    {
      path: "access_groups",
      component: AccessGroupList,
      children: [
        {
          path: '',
          redirect: '/channels/access_groups/list'
        },
        {
          path: "new",
          name: "New channel access group",
          components: {
            default: AccessGroupList,
            bottomEditor: AccessGroupEditor
          },
          props: {
            default: false,
            bottomEditor: true
          },
          meta: {
            edit: "Edit channel access group",
            search: false
          }
        },
        {
          path: "edit/:id",
          name: "Edit channel access group",
          components: {
            default: AccessGroupList,
            bottomEditor: AccessGroupEditor
          },
          props: {
            default: false,
            bottomEditor: true
          },
          meta: {
            search: false
          }
        },
        {
          path: "list",
          name: "Channel access group list",
          component: AccessGroupList,
          meta: {
            search: false
          }
        }
      ]
    }

  ],

}
</script>
